<ng-container *ngIf="type !== 'date'">
  <div *ngIf="icon">
    <input class="text-field" 
    [type]="type" 
    [required]="required" 
    placeholder="placeholder" 
    [value]="value"
    (input)="setValue($event)" 
    [ngClass]="{ 'has-error': hasError , 'acronym': acronym}" 
    [disabled]="disabled"
    [pattern]="pattern" />
    <img class="text-field-icon" src="assets/24x24/{{ icon }}" alt="icon" />
  </div>

  <div *ngIf="!icon && !assetCode">
    <input class="text-field" 
    [type]="type" 
    [required]="required" 
    [placeholder]="placeholder" 
    [value]="value"
    (input)="setValue($event)" 
    [ngClass]="{ 'has-error': hasError , 'acronym': acronym}" 
    [disabled]="disabled"
    [min]="min" 
    (keydown)="handleKeyDown($event)"/>
  </div>

  <div *ngIf="assetCode">
    <input class="text-field" 
    [type]="type" 
    [required]="required" 
    [placeholder]="placeholder" 
    [value]="value"
    (input)="setValue($event)"
    [ngClass]="{ 'has-error': hasError , 'acronym': acronym }"
    [disabled]="disabled" 
    [min]="min" 
    [ngClass]="{ disabled: 'disabled' }" />
  </div>
</ng-container>
<div *ngIf="type === 'date'" (click)="openCalendar(dateInput)">
  <input #dateInput class="text-field" 
  [type]="type" 
  [required]="required" 
  [placeholder]="placeholder" 
  [value]="value"
  (input)="setValue($event)"
  [ngClass]="{ 'has-error': hasError }" 
  [max]="max" 
  />
</div>